export default {"src":"/_next/static/media/puzzle-image.e9665574.svg","height":424,"width":636,"blurWidth":0,"blurHeight":0};